import { render } from "./EditPrintConfig.vue?vue&type=template&id=44988180"
import script from "./EditPrintConfig.vue?vue&type=script&lang=js"
export * from "./EditPrintConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__